import { Modal } from '@design-system/elements';
import {
  NameEmailForm,
  NameEmailFormFields,
} from '@design-system/forms/NameEmailForm';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { translations } from 'translations';

export type EditSignerModalProps = {
  color: string;
  setShowModal: () => void;
  isOpen: boolean;
  onSuccess: (signers) => void;
  signer?: any;
  setSigner?: (signer: any | undefined) => void;
};

export const EditSignerModal: React.FC<EditSignerModalProps> = ({
  color,
  setShowModal,
  isOpen,
  onSuccess,
  signer,
  setSigner,
}) => {
  const [disabled, setIsDisabled] = useState(true);
  const { t } = useTranslation();

  const reset = () => {
    setShowModal();
    setIsDisabled(true);

    setSigner ? setSigner(undefined) : null;
  };

  const onCancel = () => {
    setIsDisabled(true);
    setSigner ? setSigner(undefined) : null;
  };

  const handleSubmit = (values: NameEmailFormFields) => {
    onSuccess({
      uuid: signer.uuid,
      ...values,
    });
    reset();
  };

  const handleSuccess = () => {
    handleSubmit(signer as any);
  };

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );
  };

  const handleFormChange = ({ isDisabled, ...rest }) => {
    if (validateEmail(rest.email)) {
      setIsDisabled(false);
      setSigner ? setSigner({ uuid: signer.uuid, ...rest } as any) : null;
    } else {
      setIsDisabled(true);
      setSigner ? setSigner({ uuid: signer.uuid, ...rest } as any) : null;
    }
  };

  return (
    <Modal
      showModal={isOpen}
      setShowModal={setShowModal}
      onSuccess={handleSuccess}
      showCancel
      isDisabled={disabled}
      closeOnClickOutside
      handleCancel={onCancel}
      cancelText={t(translations.COMMON.CANCEL)}
      width="md:w-6/12 xl:w-4/12"
      title={t(translations.MODALS.SIGNER_TITLE_MODIFY)}
    >
      <NameEmailForm
        primaryColor={color}
        hasButton={false}
        onFormChange={handleFormChange}
        defaultValues={{
          name: signer?.name ?? '',
          email: signer?.email ?? '',
        }}
      />
    </Modal>
  );
};
